import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

import BEM from '../../../Utilities/BEM/index.jsx';

import Spinner from '../../Spinner/index.jsx';


class SubmitButton extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (this.props.onSubmit) {
      event.preventDefault();

      this.props.onSubmit(event);
    }
  }

  render() {
    var variants = [];
    if (this.props.loading) {
      variants.push('loading');
    }

    return (
      <div className={BEM.classString('cs-form-submit', variants)}>
        <Button
          type={this.props.type}
          onClick={this.onClick}
          disabled={this.props.loading || this.props.disabled}
          variant={this.props.variant}
        >
          <span className="cs-form-submit__text">{this.props.children}</span>
          <span className="cs-form-submit__spinner"><Spinner /></span>
        </Button>
      </div>
    );
  }
}


SubmitButton.propTypes = {
  type: PropTypes.string
};

SubmitButton.defaultProps = {
  type: 'submit'
};



export default SubmitButton;

